import { render, staticRenderFns } from "./Areaofinterest.vue?vue&type=template&id=dae7e2d4&scoped=true&"
import script from "./Areaofinterest.vue?vue&type=script&lang=js&"
export * from "./Areaofinterest.vue?vue&type=script&lang=js&"
import style0 from "./Areaofinterest.vue?vue&type=style&index=0&id=dae7e2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae7e2d4",
  null
  
)

export default component.exports